<template>
  <button
    class="room-card tw-flex-none tw-relative tw-overflow-clip tw-box-border tw-text-left tw-p-4 hover:tw-bg-slate-100 tw-border-b"
    :class="getBG()"
    @click="onClick"
  >
    <div class="tw-flex tw-flex-wrap tw-space-x-2 tw-items-center">
      <p class="tw-font-bold">{{ roomProps.CreatorName }}</p>
      <span
        class="tw-rounded tw-h-min tw-px-2 tw-text-xs tw-text-white"
        :class="{
          'tw-bg-green-500 ': roomProps.Status === 'opened',
          'tw-bg-red-500': roomProps.Status === 'closed',
          'tw-bg-orange-500': roomProps.Status === 'abandon',
        }"
        >{{ roomProps.Status | status }}</span
      >
    </div>
    <!-- Last message -->
    <p
      class="max-show-line tw-text-sm"
      :class="{
        'tw-text-gray-400': !lastMessage,
        'tw-text-gray-500': lastMessage,
      }"
    >
      {{ lastMessage | filterMessage }}
    </p>
    <div
      class="tag-list tw-gap-2 tw-w-full tw-mt-2 tw-flex tw-flex-wrap tw-mb-2"
    >
      <RoomCardTag
        v-for="(tag, index) in tags"
        :key="index"
        :tag="tag"
      ></RoomCardTag>
    </div>
    <p class="tw-text-xs tw-text-slate-400">
      {{ roomProps.UpdatedAt | formatDate }}
    </p>
    <div
      v-if="selected"
      class="tw-absolute tw-h-full tw-w-2 tw-top-0 tw-left-0 tw-bg-slate-400"
    ></div>
    <div
      v-if="unreadMessage && !this.selected"
      class="tw-absolute tw-z-[1] tw-top-4 tw-right-4"
    >
      <div
        class="unread-badge tw-absolute tw-animate-ping tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
      ></div>
      <div
        class="unread-badge tw-absolute tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"
      ></div>
    </div>
  </button>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { EventBus } from "@/event-bus";
// var audio = new Audio("https://files.fm/down.php?i=3ersafth8");

dayjs.extend(localizedFormat);

export default {
  name: "RoomCard",
  props: ["roomProps", "selected", "socket"],
  components: {
    RoomCardTag: () => import("./RoomCardTag.vue"),
  },
  data() {
    return {
      // tags: [],
      loaded: false,
      show: false,
    };
  },
  computed: {
    ...mapGetters({
      decoded: "chat/decoded",
    }),
    userID() {
      const user = this.$store.getters["chat/decoded"];
      return user["cognito:username"] || null;
    },
    lastMessage() {
      if (this.roomProps?.MainChannel?.LastMessage?.Type === "text") {
        return this.roomProps.MainChannel.LastMessage.Text;
      }
      if (this.roomProps?.MainChannel?.LastMessage.Type === "image") {
        return "Image";
      }
      return null;
    },
    tags() {
      // IssueTags CustomerTags OrderTags
      return [
        ...this.roomProps.IssueTags,
        ...this.roomProps.CustomerTags,
        ...this.roomProps.OrderTags,
      ];
    },
    isMainParticipant() {
      const mainParticipants = this.roomProps.MainChannel?.Participants || [];
      return mainParticipants.findIndex((p) => p.ID === this.userID) >= 0;
    },
    isBackgroundParticipant() {
      const backgroundParticipants =
        this.roomProps.BackgroundChannel?.Participants || [];
      return backgroundParticipants.findIndex((p) => p.ID === this.userID) >= 0;
    },
    isParticipant() {
      return this.isMainParticipant || this.isBackgroundParticipant;
    },
    unreadMessage() {
      if (!this.isParticipant) {
        return false;
      }
      if (
        this.roomProps.MainChannel?.LastMessage?.Type ||
        this.roomProps.BackgroundChannel?.LastMessage?.Type
      ) {
        const mainSeenBy =
          this.roomProps.MainChannel?.LastMessage?.SeenBy || [];
        const bgSeenBy =
          this.roomProps.BackgroundChannel?.LastMessage?.SeenBy || [];

        const unreadMain =
          mainSeenBy.length > 0
            ? mainSeenBy.findIndex((seen) => seen === this.userID) === -1
            : false;
        const unreadBackground =
          bgSeenBy.length > 0
            ? bgSeenBy.findIndex((seen) => seen === this.userID) === -1
            : false;
        return unreadMain || unreadBackground;
      }
      return false;
    },
  },
  created() {
    this.room = this.roomProps;
  },
  mounted() {
    // this.updateLocalTags();
    // EventBus.$on("update-local-tags", () => {
    //   if (this.selected) this.updateLocalTags();
    // });
    // EventBus.$on("update-local-room", (event) => {
    //   this.updateLocalRoom(event);
    // });
    // EventBus.$on("update-last-message", (event) => {
    //   this.updateLastMessage(event);
    // });
    EventBus.$on("new-socket-message", (event) => {
      console.log("EventBus new-socket-message", event);
      if (event.message?.RoomID === this.roomProps.RoomID) {
        if (event.message.Channel === "main" && this.isMainParticipant) {
          event.callback();
        } else if (
          event.message.Channel === "background" &&
          this.isBackgroundParticipant
        ) {
          event.callback();
        }
      }
    });
  },
  methods: {
    onClick() {
      this.$emit("click-room");
    },
    getBG() {
      return this.selected ? "tw-bg-slate-100" : "";
    },
    // async updateLocalTags() {
    //   let tags = [];
    //   this.roomProps.IssueTags?.map((t) => tags.push(t));
    //   this.roomProps.CustomerTags?.map((t) => tags.push(t));
    //   this.roomProps.OrderTags?.map((t) => tags.push(t));
    //   this.tags = tags;
    // }, IssueTags CustomerTags OrderTags
  },
  filters: {
    formatDate(val) {
      if (dayjs(val).isSame(dayjs(), "day")) {
        return dayjs(val).format("LT");
      }
      return dayjs(val).format("ll");
    },
    status(value) {
      if (!value) {
        return "n/a";
      }
      if (value === "opened") {
        return "Open";
      }
      if (value === "closed") {
        return "Close";
      }
      if (value === "abandon") {
        return "Pending reply";
      }
      return value;
    },
    // messageText(message) {
    //   let senderID = message.SenderID.split(/[-_]/)[0];
    //   if (message.Type === "image") {
    //     return `${senderID}: Sent a photo`;
    //   }
    //   return `${senderID}: ${message.Text}`;
    // },
    filterMessage(lastMessage) {
      return lastMessage || "No message";
    },
  },
  beforeDestroy() {
    EventBus.$off("update-local-tags");
    // EventBus.$off("update-local-room");
  },
};
</script>

<style scoped>

/* * {
    border: 1px solid red;
} */
.max-show-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

</style>
